'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlogCarousel = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

require('slick-carousel');

var _CarouselSection2 = require('./../carousel/CarouselSection');

var _ShopifySection = require('./../ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Blog Carousel
 *    Scripts for the blog carousel utilising Slick.
 *
 *
 *  Version:
 *    1.0.0 - 2020/08/11
 */

var CONTAINER_SELECTOR = '[data-blog-carousel-container]';
var CAROUSEL_SELECTOR = '[data-blog-carousel]';

var BlogCarousel = exports.BlogCarousel = function (_CarouselSection) {
  (0, _inherits3.default)(BlogCarousel, _CarouselSection);

  function BlogCarousel(container) {
    (0, _classCallCheck3.default)(this, BlogCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BlogCarousel.__proto__ || Object.getPrototypeOf(BlogCarousel)).call(this, container));

    _this.container = container;
    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);

    _this.slick = _this.initCarousel(_this.carouselContainer);
    return _this;
  }

  (0, _createClass3.default)(BlogCarousel, [{
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        responsive: [{
          breakpoint: ResponsiveSizes.medium - 1,
          settings: {
            slidesToShow: 3,
            arrows: true
          }
        }]
      };
    }
  }]);
  return BlogCarousel;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, BlogCarousel);